import axios from "axios";
import { API_BASE } from "./api";

const SID_KEY = "alta_funnel_sid";
const FIRED_KEY = "alta_funnel_fired";

function genId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
  return Math.random().toString(36).slice(2) + Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function getSessionId() {
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid || sid.length < 8) {
      sid = genId();
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch (_) {
    return genId();
  }
}

function readFired() {
  try {
    const raw = localStorage.getItem(FIRED_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_) {
    return {};
  }
}
function writeFired(obj) {
  try { localStorage.setItem(FIRED_KEY, JSON.stringify(obj)); } catch (_) { /* ignore */ }
}

export function getUtmSource() {
  try {
    const p = new URLSearchParams(window.location.search);
    return p.get("utm_source") || null;
  } catch (_) { return null; }
}

/**
 * Track an anonymous funnel event. Fire-and-forget.
 * @param {string} eventType one of: page_view | role_selected | form_filled_basic | submit_clicked | registration_success
 * @param {object} opts { role, discovery_source, meta, once }
 */
export function trackFunnel(eventType, opts = {}) {
  const { role = null, discovery_source = null, meta = null, once = false } = opts;
  if (once) {
    const fired = readFired();
    const key = `${eventType}:${role || "_"}`;
    if (fired[key]) return;
    fired[key] = Date.now();
    writeFired(fired);
  }
  const payload = {
    session_id: getSessionId(),
    event_type: eventType,
    role,
    discovery_source: discovery_source || undefined,
    utm_source: getUtmSource() || undefined,
    meta: meta || undefined,
  };
  // Fire-and-forget; do not block UI on errors
  axios.post(`${API_BASE}/funnel/event`, payload, { timeout: 4000 }).catch(() => { /* swallow */ });
}
